import { render, staticRenderFns } from "./platformTaskDetail.vue?vue&type=template&id=1cc8d55d&scoped=true"
import script from "./platformTaskDetail.vue?vue&type=script&lang=js"
export * from "./platformTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./platformTaskDetail.vue?vue&type=style&index=0&id=1cc8d55d&prod&scoped=true&lang=css"
import style1 from "./platformTaskDetail.vue?vue&type=style&index=1&id=1cc8d55d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc8d55d",
  null
  
)

export default component.exports